import { reactive } from 'vue'

export function useCommentConfirmDeleteModal() {
  const commentConfirmDeleteModalProps = reactive({
    show: false,
    comment: null,
  })

  function showCommentConfirmDeleteModal(comment) {
    commentConfirmDeleteModalProps.comment = comment
    commentConfirmDeleteModalProps.show = true
  }

  function closeCommentConfirmDeleteModal() {
    commentConfirmDeleteModalProps.show = false
  }

  return {
    commentConfirmDeleteModalProps,
    showCommentConfirmDeleteModal,
    closeCommentConfirmDeleteModal,
  }
}
